var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var Component_1 = require("../Component");
var OnClickHandler_1 = require("./Dependencies/OnClickHandler");
var MODAL_CLASS = 'modal-open';
var Modal = (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.setClickOutsideHandler = function () {
            _this.clickOutsideHandler = new OnClickHandler_1.default(ReactDOM.findDOMNode(_this.refs.modalContent), function () {
                _this.handleClose(true);
            });
        };
        _this.handleKeyPress = function (event) {
            if (event.keyCode == 27 && _this.props.isCloseOnEscape) {
                _this.handleClose();
            }
        };
        var isOpen = _this.props.isOpen;
        _this.state = {
            isOpen: isOpen,
        };
        return _this;
    }
    Modal.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.isOpen != undefined &&
            nextProps.isOpen !== this.props.isOpen) {
            this.setState({
                isOpen: nextProps.isOpen,
            });
        }
        if (this.props.isCloseOnOutSideClick !== nextProps.isCloseOnOutSideClick) {
            this.setClickOutsideHandler();
        }
    };
    Modal.prototype.componentDidMount = function () {
        if (this.props.isCloseOnOutSideClick) {
            this.setClickOutsideHandler();
        }
        if (this.props.isCloseOnEscape) {
            window.addEventListener('keydown', this.handleKeyPress);
        }
        if (this.props.isPreventScrolling) {
            document.body.classList.add(MODAL_CLASS);
        }
    };
    Modal.prototype.componentWillUnmount = function () {
        if (this.clickOutsideHandler)
            this.clickOutsideHandler.dispose();
        window.removeEventListener('keydown', this.handleKeyPress);
        document.body.classList.remove(MODAL_CLASS);
    };
    Modal.prototype.componentWillUpdate = function (nextProps, nextState) {
        if (this.props.isPreventScrolling &&
            nextProps.isOpen !== this.props.isOpen) {
            document.body.classList.toggle(MODAL_CLASS, !!nextProps.isOpen);
        }
    };
    Modal.prototype.handleClose = function (isOutSideClick) {
        var _this = this;
        if (isOutSideClick === void 0) { isOutSideClick = false; }
        if (!isOutSideClick || this.props.isCloseOnOutSideClick) {
            this.setState({
                isOpen: false,
            }, function () {
                if (_this.props.onClose) {
                    _this.props.onClose();
                }
            });
        }
    };
    Modal.prototype.render = function () {
        var _a = this.props, _b = _a.customParentClass, customParentClass = _b === void 0 ? '' : _b, _c = _a.customClass, customClass = _c === void 0 ? '' : _c, customFooterClass = _a.customFooterClass, customHeaderClass = _a.customHeaderClass, headerOnTop = _a.headerOnTop, _d = _a.footer, footer = _d === void 0 ? false : _d, _e = _a.header, header = _e === void 0 ? false : _e, type = _a.type, size = _a.size, theme = _a.theme;
        var isOpen = this.state.isOpen;
        var popup = type == 'popup' ? 'cf-modal--popup ' : '';
        var themeType = theme ? "cf-modal--" + theme : '';
        var reveal = isOpen ? 'reveal' : '';
        var parentClassName = "cf-modal " + customParentClass + " " + reveal + " " + popup + " " + themeType;
        var className = "cf-modal__content modal-bounce-in " + customClass + " " + size;
        var headerClassName = (headerOnTop ? 'cf-modal__title--top' : '') + " " + customHeaderClass;
        var closeIconClassName = "cf-modal__close " + (headerOnTop ? 'cf-modal__close--top' : '');
        return (React.createElement("div", { ref: "Modal" },
            React.createElement("div", { ref: "modalBg", className: parentClassName },
                React.createElement("div", { ref: "modalContent", className: className },
                    this.props.isShowCloseIcon == true ? (React.createElement("div", { className: closeIconClassName, onClick: this.handleClose.bind(this, false) })) : null,
                    header && React.createElement("div", { className: headerClassName }, header),
                    this.props.children,
                    footer && React.createElement("div", { className: customFooterClass }, footer)))));
    };
    Modal.defaultProps = {
        isOpen: false,
        customClass: '',
        size: 'small',
        isCloseOnOutSideClick: true,
        isCloseOnEscape: true,
        customHeaderClass: '',
        customFooterClass: '',
        isShowCloseIcon: false,
        isPreventScrolling: true,
        headerOnTop: false,
    };
    return Modal;
}(Component_1.default));
exports.default = Modal;
